import(/* webpackMode: "eager" */ "/app/app/[lang]/page.tsx");
